import { useDataChange, useDataValue } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })
  let locations = useDataValue({
    context: 'locations',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(next => {
      let location = locations.find(item => item.id === value)
      if (location) {
        next.location_id = location.id
        next.location__id = location._id
      } else {
        next.location_id = null
        next.location__id = null
      }
    })
  }
}
